<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "AsyncForm",

        props: {
            callback: {
                type: Function,
                required: true
            }
        },

        data() {
            return {
                form: null
            }
        },

        mounted() {
            this.form = this.$el.getElementsByTagName('form')[0];

            this.form.addEventListener('submit', (e) => {
                e.preventDefault();

                console.log(this.form);

                axios({
                    'method': this.form.attributes.method.value,
                    'url': this.form.attributes.action.value,
                    'data': new FormData(this.form)
                }).then((response) => {
                    this.callback(response.data, window);
                });
            });
        }
    }
</script>
